import { clientApi } from '../../configuration';
import { getPermissionsHook } from '../../utils';

type UserProjectsPermissionCodes = 'CAN_EDIT_PROJECT' | 'CAN_GET_SUPPORT_GUIDES';

interface FetchProps {
  userId: number;
  projectId: number;
}

const useProjectsPermissions = getPermissionsHook<UserProjectsPermissionCodes, FetchProps>({
  entityName: 'userProjectsPermissions',
  fetch: ({ userId, projectId }: FetchProps) =>
    clientApi.getOCClient().helpers.user.users.id(userId).projects.id(projectId).permissions.find(),
});

export default useProjectsPermissions;
